import React, { useState, useEffect } from 'react';
import './ReportsModal.css';
import * as Yup from 'yup';
import Form from '../../form/components/Form/Form';
import FormField from '../../form/components/FormField/FormField';
import Button from '../../form/components/Button/Button';
import ErrorMessage from '../../form/components/ErrorMessage/ErrorMessage';
import { ImCancelCircle } from 'react-icons/im';
import { FaCloudUploadAlt, FaTrashAlt } from  'react-icons/fa';
import { useRef } from 'react';
import { toast } from 'react-toastify';
import BeatLoader from "react-spinners/BeatLoader";
import ProgressBar from '../../Progress/Progress';
import moment from 'moment';
import { auth } from '../../../firebase/firebase-config';
import { doc, collection,query, where, getDocs, addDoc, getDoc, updateDoc, arrayUnion   } from "firebase/firestore"; 
import { getStorage,  ref, uploadBytesResumable, getDownloadURL, deleteObject} from 'firebase/storage';

import { firebaseApp,  } from '../../../utils/firebaseConfig';
import { useAuthState } from 'react-firebase-hooks/auth';
import { db } from "../../../firebase/firebase-config";
import html2canvas from 'html2canvas';
import { useTranslation } from 'react-i18next';

import Webcam from 'react-webcam';
import { jsPDF } from 'jspdf';
import Jimp from 'jimp';

import Tippy from '@tippyjs/react';
import 'tippy.js/dist/tippy.css';

const initialValues= {
    report_name: ''
}

const override = {
    marginTop: '20px'
  };



function LabReportModal({ onClose, onContentAdded, patient } : any) {
    const [error, setError] = useState<any>(null);
    const [loading, setLoading] = useState(false);
    const currentDate = moment();
    const [user] = useAuthState(auth);
    const { t, i18n } = useTranslation();

    const webcamRef = React.useRef(null);
    const [capturedImage, setCapturedImage] = useState(null);

    // REPORT PDF
    const [reportPdfUrl, setReportPdfUrl] = useState<any>('');
    const [reportType, setReportType] = useState<any>('');
    const [reportsPdfProgress,  setReportPdfProgress] = useState(0);
    const [isUploadingReportPdf, setIsUploadingReportPdf] = useState(false);

    // END OF ASSIGNEMTN
    const storage = getStorage(firebaseApp);
    

    // good
    const reportFileRef: any = useRef(null);

    const validationSchema = Yup.object().shape({
        report_name: Yup.string().required('Report name is required')
    })

    const uploadNormalPdf = (e: any) => {

      const selectedFile = e.target.files[0]; 

      // console.log('EVENT: ', selectedFile.type);
      // return;
      if(selectedFile.type === 'application/pdf') {
        setIsUploadingReportPdf(true);
        const pdfFile: any = e.target.files[0];
        const storageRef = ref(storage, `pdf/${Date.now()}-${pdfFile.name}`);
        const uploadTask = uploadBytesResumable(storageRef, pdfFile);
  
        console.log(e.target.files[0]);   
      
        uploadTask.on('state_changed', (snapshot: any)=>{
            const uploadProgress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
    
            setReportPdfProgress(+uploadProgress);
    
        }, (error: any) => {
            console.log(error);
        },()=> {
            getDownloadURL(uploadTask.snapshot.ref).then((downloadURL) => {
              setReportPdfUrl(downloadURL);
              setReportType('pdf')
                // console.log('URL', reportPdfUrl);
                // console.log('PDF  URL: ', downloadURL);
                setIsUploadingReportPdf(false);
            });
        })
      }else {
        setIsUploadingReportPdf(true);
        const pdfFile: any = e.target.files[0];
        const storageRef = ref(storage, `img_reports/${Date.now()}-${pdfFile.name}`);
        const uploadTask = uploadBytesResumable(storageRef, pdfFile);
  
        console.log(e.target.files[0]);   
      
        uploadTask.on('state_changed', (snapshot: any)=>{
            const uploadProgress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
    
            setReportPdfProgress(+uploadProgress);
    
        }, (error: any) => {
            console.log(error);
        },()=> {
            getDownloadURL(uploadTask.snapshot.ref).then((downloadURL) => {
              setReportPdfUrl(downloadURL);
              setReportType('picture')
                // console.log('URL', reportPdfUrl);
                // console.log('PDF  URL: ', downloadURL);
                setIsUploadingReportPdf(false);
            });
        })
      }
  
    }



    const uploadReportPdf = (e: any) => {
        setIsUploadingReportPdf(true);
      const pdfFile: any = e.target.files[0];
      const storageRef = ref(storage, `pdf/${Date.now()}-${pdfFile.name}`);
    
      const uploadTask = uploadBytesResumable(storageRef, pdfFile);

      console.log(e.target.files[0]);   
  
    uploadTask.on('state_changed', (snapshot: any)=>{
        const uploadProgress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;

        setReportPdfProgress(+uploadProgress);

    }, (error: any) => {
        console.log(error);
    },()=> {
         getDownloadURL(uploadTask.snapshot.ref).then((downloadURL) => {
            setReportPdfUrl(downloadURL);
            // console.log('PDF  URL: ', downloadURL);
            setIsUploadingReportPdf(false);
        });
    })
  }




    const handleSubmitReport = async (values: any) => {

            const formattedDate = currentDate.format('YYYY-MM-DD');
            // const cityRef = doc(firebaseApp, 'Cases', values.case_id);
            setLoading(true);
         
            let reqData = {    
                ...values,
                document_url: reportPdfUrl,
                created_at: formattedDate,
                report_type: reportType
            }

  
            
            // console.log('VALS: ', data);
           
            if(reportPdfUrl?.length < 2) {
                toast.error("Report File Needed", {
                    pauseOnHover: false,
                    closeOnClick: true,
                })
                setLoading(false);
                return;
            }

            // console.log(reqData);

              // UPDATE ARRAY REPORTS ARRAY ON FIREBASE FOR THIS PATIENT
              const patientReportDocRef =  query(collection(db, "Reports"), where("phone", "==", patient?.phone), where("owner", "==", user?.uid));
              const docs = await getDocs(patientReportDocRef);
              let data: any =  [];
  
              docs.forEach(val => {
                  data.push({
                      ...val.data(),
                      id: val.id
                  }); 
              })
  
              try {
                  let docRef =  doc(collection(db, 'Reports'), data[0].id);
  
                  await updateDoc(docRef, {
                      reports: arrayUnion(reqData)
                  })
  
                  setLoading(false);
                  onContentAdded();
                  onClose();
                  toast.success('Report Uploaded', {
                      pauseOnHover: false,
                      closeOnClick: true,
                  })
              } catch (error) {
                  setLoading(false);
                  toast.error("ERROR", {
                      pauseOnHover: false,
                      closeOnClick: true,
                  })
              }

        // try {
        //     const docRef = collection(db,"Reportss")
        
        //    await addDoc(docRef, reqData);

        //     setLoading(false);
        //     onClose();
        //     onContentAdded();
        //     toast.success('Report Created', {
        //         pauseOnHover: false,
        //         closeOnClick: true,
        //     })

        
        //    } catch (error) {
        //     console.log('DATA: ', error);
        //     setLoading(false);
        //     toast.error("ERROR", {
        //         pauseOnHover: false,
        //         closeOnClick: true,
        //     })
        //    }
    }

    const uploadPDFToFirebase = async(pdfBlob: any) => {
        // Generate PDF using jsPDF
        // const pdf: any = new jsPDF();
        // pdf.addImage(capturedImage, 'PNG', 10, 10);
        
        // // Convert PDF to blob
        // const pdfBlob = pdf.output('blob');

        // Upload PDF to Firebase Storage
        const storageRef = ref(storage, `pdf/${Date.now()}-canvas.pdf`);
        
        const uploadTask = uploadBytesResumable(storageRef, pdfBlob);

        uploadTask.on('state_changed', (snapshot: any) => {
            const uploadProgress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
            setReportPdfProgress(+uploadProgress);
          }, (error: any) => {
            console.log(error);
          }, async () => {
            const downloadURL = await getDownloadURL(uploadTask.snapshot.ref);
            setReportPdfUrl(downloadURL);
            // console.log('PDF URL: ', downloadURL);
            setIsUploadingReportPdf(false);
      })
      
  }

    const createReport = async() => {
        const formattedDate = currentDate.format('YYYY-MM-DD');
        setLoading(true);

        // Generate PDF using jsPDF
        const pdf: any = new jsPDF();
        pdf.addImage(capturedImage, 'PNG', 10, 10);
        
        // Convert PDF to blob
        const pdfBlob = pdf.output('blob');

        // Upload PDF to Firebase Storage
        const storageRef = ref(storage, `pdf/${Date.now()}-canvas.pdf`);
        const uploadTask = uploadBytesResumable(storageRef, pdfBlob);

        uploadTask.on('state_changed', (snapshot: any) => {
            const uploadProgress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
            setReportPdfProgress(+uploadProgress);
          }, (error: any) => {
            // console.log(error);
          }, async () => {
            const downloadURL = await getDownloadURL(uploadTask.snapshot.ref);
            setReportPdfUrl(downloadURL);
            // console.log('PDF URL: ', downloadURL);
            setIsUploadingReportPdf(false);

            let reqData =  {
                document_url: downloadURL,
                created_at: formattedDate
            }

            // UPDATE ARRAY REPORTS ARRAY ON FIREBASE FOR THIS PATIENT
            const patientReportDocRef =  query(collection(db, "Reports"), where("phone", "==", patient?.phone), where("owner", "==", user?.uid));
            const docs = await getDocs(patientReportDocRef);
            let data: any =  [];

            docs.forEach(val => {
                data.push({
                    ...val.data(),
                    id: val.id
                });
            })

            try {
                let docRef =  doc(collection(db, 'Reports'), data[0].id);

                await updateDoc(docRef, {
                    reports: arrayUnion(reqData)
                })

                setLoading(false);
                onContentAdded();
                onClose();
                toast.success('Report Uploaded', {
                    pauseOnHover: false,
                    closeOnClick: true,
                })
            } catch (error) {
                setLoading(false);
                toast.error("ERROR", {
                    pauseOnHover: false,
                    closeOnClick: true,
                })
            }

          });

    }

    const handleFileChange = async () => {
        if (reportFileRef.current?.files && reportFileRef.current.files.length > 0) {
            const imageFile = reportFileRef.current.files[0];
            const pdfBlob = await convertImageToPDF(imageFile);

            // Upload the PDF to Firebase Storage
            uploadPDFToFirebase(pdfBlob);

          }
      };

  
    
      const createPDFFromImage = async (imageDataURL: string) => {
        const pdf = new jsPDF();
        const imgWidth = pdf.internal.pageSize.getWidth();
        const imgHeight = pdf.internal.pageSize.getHeight();
        pdf.addImage(imageDataURL, 'JPEG', 0, 0, imgWidth, imgHeight);
        pdf.save('converted_image.pdf');
      };


      const convertImageToPDF = async (imageFile: any) => {
        const imageDataURL = await getImageDataURL(imageFile);
        createPDFFromImage(imageDataURL);
      };


      const getImageDataURL = (file: File) => {
        return new Promise<string>((resolve) => {
          const reader = new FileReader();
          reader.onload = (event) => {
            const dataURL = event.target?.result as string;
            resolve(dataURL);
          };
          reader.readAsDataURL(file);
        });
      };


    const capture = (webcamRef: any) => {
        const imageSrc = webcamRef.current.getScreenshot();
        // Now you can process or display the captured image
        setCapturedImage(imageSrc);
      };

    //   const applyScannerEffect = async () => {
    //     if (!capturedImage) return;
    
    //     try {
    //       const image = await Jimp.read(Buffer.from(capturedImage, 'base64'));
    
    //       // Apply scanner effect
    //       image.scan(0, 0, image.bitmap.width, image.bitmap.height, (x, y, idx) => {
    //         const brightness = (image.bitmap.data[idx] + image.bitmap.data[idx + 1] + image.bitmap.data[idx + 2]) / 3;
    //         image.bitmap.data[idx] = brightness;
    //         image.bitmap.data[idx + 1] = brightness;
    //         image.bitmap.data[idx + 2] = brightness;
    //       });
    
    //       const processedImageSrc:  any = await image.getBase64Async(Jimp.MIME_JPEG);
    //       setCapturedImage(processedImageSrc);
    //     } catch (error) {
    //       console.error('Error applying scanner effect:', error);
    //     }
    //   };

    const applyScannerEffect = () => {
        const canvas: any = document.createElement('canvas');
        const ctx: any = canvas.getContext('2d');
        const image: any = new Image();
        image.src = capturedImage;

        image.onload = () => {
          canvas.width = image.width;
          canvas.height = image.height;
      
          // Draw the image onto the canvas
          ctx.drawImage(image, 0, 0, canvas.width, canvas.height);
      
          // Adjust brightness by increasing pixel values
          const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
          const data = imageData.data;
      
          for (let i = 0; i < data.length; i += 4) {
            // Increase pixel values to brighten the image
            data[i] += 50; // R
            data[i + 1] += 50; // G
            data[i + 2] += 50; // B
          }
      
          ctx.putImageData(imageData, 0, 0);
      
          // Set the processed image as the capturedImage state
          setCapturedImage(canvas.toDataURL('image/png'));
        };
      };





    useEffect(() => {
        // console.log('PATIENT: ',  patient);
    },[patient])


    
    return (
        <div>
            <div  className='modal-container student-modal-assignment' id="reports-modal">
                <div className='modal-head'>
                    <p className="modal-title">{t('lab.upload_modal.title')} {patient?.phone}</p>
                    <ImCancelCircle style={{cursor: 'pointer'}} onClick={onClose} size={22} color="#fff"/>
                </div>
                <div className='modal-content'>
                <div style={{textAlign: 'center', marginBottom: '10px'}}>
                    <BeatLoader
                        color="#3080ED" 
                        loading={loading}
                        cssOverride={override}
                    />
                </div>
                {/* {!capturedImage && <Webcam
                            audio={false}
                            width={'100%'} 
                            ref={webcamRef}
                            screenshotFormat="image/jpeg"
                        />}
                          {capturedImage && <img src={capturedImage} alt="Captured" />}
                         <div style={{display: 'flex', gap:  '20px'}}>
                           {!capturedImage && <button className={`u-margin-bottom-small btn-auth not-full-width`}  onClick={() => capture(webcamRef)}>Capture</button>}
                           {capturedImage && <><button className={`u-margin-bottom-small btn-auth not-full-width`}  onClick={() => {
                            setCapturedImage(null);
                           }}>Re Capture</button>
                            <button className={`u-margin-bottom-small btn-auth not-full-width`}  onClick={() => createReport()}>Submit Report</button> </>}
                         </div> */}
                <form action="" className="auth-form">

                {error && <ErrorMessage error={error} visible={true} />}
                
                <Form 
                    initialValues={initialValues}
                    onSubmit={handleSubmitReport}
                    validationSchema={validationSchema}
                >


                        <p className="label-text">{t('lab.upload_modal.report_name')}: </p>
                        <FormField  name="report_name" type="general" placeholder={`${t('lab.upload_modal.report_name')}`}/>
                        

                        <div className='upload-content-container'>

                          {reportPdfUrl?.length < 2 &&  <div className="form-field-upload content-upload-right">
                            <p className="label-text">{t('lab.upload_modal.upload_report')}: </p>
                            <div className="file-drop-upload" onClick={() => reportFileRef.current.click()}>
                            {!isUploadingReportPdf && <FaCloudUploadAlt size={35} color="#FFA500" />}
                                <input ref={reportFileRef} onChange={uploadNormalPdf} type="file" style={{width: '100%', height: '100%', display: 'none'}} accept=".pdf, .png, .jpeg, .jpg"/>
                                {isUploadingReportPdf &&  <div style={{width: '80%', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center'}}>
                              <BeatLoader
                                    color="#3080ED" 
                                    loading={isUploadingReportPdf}
                                    cssOverride={override}
                                />
                                <p style={{fontSize: '14px'}}>{t('lab.upload_modal.uploading')}</p>
                            
                                    <ProgressBar bgcolor={'#6a1b9a'} completed={reportsPdfProgress}/>
                                
                              </div>}
                        
                            </div>
                        </div>}

                        {reportPdfUrl.length > 2 &&
                            <div className="form-field-upload content-upload-right">
                            <p className="label-text" style={{textAlign: 'center'}}>{('lab.upload_modal.done')}</p>
                            </div>
                            }
                        </div>
               
                      {!loading && <Button isOutLined={true} isFullWidth={false} title={`${t('lab.upload_modal.submit_report')}`}/>}

                        </Form>
                </form>
                </div>
            </div>
            <div className="modal-shadow" onClick={onClose}>
               
            </div>
        </div>
    );
}

export default LabReportModal;

